import React, { Component } from 'react';
import axios from 'axios';
import { FB_URL
} from '../../store/actions/types'

class EmailVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: '',
      step: 'send', // 'send' or 'verify'
      message: '',
      loading: false,
      error: '',
    };
  }

// sendOtp = async () => {
//   this.setState({ loading: true, error: '', message: '' });

//   try {
//     const res = await axios.post(`${FB_URL}/m119-resendotp`, {
//       task: 'sendOtp',
//       email: this.props.email.toLowerCase().trim(),
//     });

//     if (res.data.success === true) {
//       this.setState({
//         message: res.data.message || 'Verification code sent!',
//         step: 'verify',
//       });
//     } else {
//       this.setState({
//         error: res.data.error || 'Failed to send code',
//       });
//     }
//   } catch (err) {
//     console.error('Send OTP error:', err);
//     this.setState({
//       error: err.response?.data?.error || 'Network error. Please try again.',
//     });
//   } finally {
//     this.setState({ loading: false });
//   }
// };

  // Expect props: email (string, required), and optional callbacks
  // e.g., onVerified() to proceed to 2FA or login

  sendOtp = async () => {
    this.setState({ loading: true, error: '', message: '' });
    console.log('EmailVerification: ', this.props.email);
    
    try {
      var res = await axios.post(`${FB_URL}/m119-resendotp`, {
          params: {
              task: 'sendOtp', //user wallet address  
              email: this.props.email.toLowerCase().trim(),
              otp: ''                   
          }
        })

      if (res.data.success === true) {
      this.setState({
        message: response.data.message || 'OTP sent to your email',
        step: 'verify',
      });
      }
      else {
        this.setState({
        error: err.response?.data?.error || 'Failed to send OTP. Try again.',
      });
      };

    } catch (err) {
      this.setState({
        error: err.response?.data?.error || 'Failed to send OTP. Try again.',
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  verifyOtp = async () => {
    this.setState({ loading: true, error: '', message: '' });

    try {
      // const response = await axios.post('/api/email/verify-otp', {
      //   email: this.props.email,
      //   otp: this.state.otp.trim(),
      // });
      var res = await axios.post(`${FB_URL}/m119-resendotp`, {
          params: {
              task: 'verifyotp', //user wallet address  
              email: this.props.email.toLowerCase().trim(),
              otp: this.state.otp.trim(),                   
          }
        })

      if (res.data.success === true) {
      this.setState({
        message: response.data.message || 'Email verified successfully!',
      });
      }
      // Notify parent (your login component) that verification succeeded
      if (this.props.onVerified) {
        this.props.onVerified();
      }
    } catch (err) {
      this.setState({
        error: err.response?.data?.error || 'Invalid or expired code',
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleOtpChange = (e) => {
    this.setState({ otp: e.target.value });
  };

  render() {
    const { email } = this.props;
    const { step, otp, message, error, loading } = this.state;

    return (
      <div className="email-verification">
        {step === 'send' ? (
          <>
            <button
              onClick={this.sendOtp}
              disabled={loading}
              className="btn-primary"
            >
              {loading ? 'Sending...' : 'Email Verification Code'}
            </button>
          </>
        ) : (
          <>
            <p>Enter the 6-digit code sent to <strong>{email}</strong></p>
            <input
              type="text"
              value={otp}
              onChange={this.handleOtpChange}
              placeholder="123456"
              maxLength="6"
              autoFocus
              className="otp-input"
              disabled={loading}
            />
            <div className="button-group">
              <button
                onClick={this.verifyOtp}
                disabled={loading || otp.length !== 6}
                className="btn-primary"
              >
                {loading ? 'Verifying...' : 'Verify Code'}
              </button>
              <button
                onClick={this.sendOtp}
                disabled={loading}
                className="btn-secondary"
              >
                Resend Code
              </button>
            </div>
          </>
        )}

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
      </div>
    );
  }
}

export default EmailVerification;